export default __webpack_public_path__ + "static/floor1-slide-6-c7ad15c63d7591429c52fcc71966dc72.jpg";